// Montessori
import React from 'react';
import NationalSpaceDay2025  from 'views/NationalSpaceDay2025';

const Montessoripage = () => {
  return <NationalSpaceDay2025/>;
};

export default Montessoripage;